import { Asset } from '../..';
import { equityOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { EquityListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const EquityAsset = () => {
  return (
    <Asset
      productsQuery={equityOffersQueryUpdated}
      ProductItem={EquityListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
